import { Component, Input } from '@angular/core';

import { Question } from '@empathy/survey/base';

@Component({
  selector: 'empathy-info-page-question-view',
  templateUrl: 'info-page-question-view.component.html',
  styleUrls: ['./info-page-question-view.component.scss']
})
export class InfoPageQuestionViewComponent {
  @Input() question: Question;
}
